<div class="file-modal">
    <div class="file-modal__header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="file-modal__close" (click)="activeModal.dismiss()" [disabled]="submitting"
            [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <form class="file-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>{{ 'field_title' | translate }}</span>
            <input ngbAutofocus type="text" name="title" [(ngModel)]="title" autocomplete="off"
                [class.invalid]="titleInvalid" [class.shake]="shaking && titleInvalid" />
        </label>

        <label class="field">
            <span>{{ 'field_description' | translate }}</span>
            <input type="text" name="descr" [(ngModel)]="descr" autocomplete="off" />
        </label>

        <div class="field">
            <span>{{ 'field_category' | translate }}</span>
            <ng-select
                class="tool-select"
                name="categoryId"
                [items]="categories"
                bindLabel="categoryName"
                bindValue="id"
                [placeholder]="'file_modal_category_placeholder' | translate"
                [(ngModel)]="categoryId">
            </ng-select>
        </div>

        <div class="field">
            <span>{{ 'file_modal_field_file' | translate }}</span>
            <input type="file" name="file" (change)="onFileSelected($event)"
                [class.invalid]="fileInvalid" [class.shake]="shaking && fileInvalid" />
            @if (isEdit && existingFilename && !fileBase64) {
                <small class="hint">{{ 'file_modal_current_file' | translate: { filename: existingFilename } }}</small>
            }
        </div>

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="file-modal__submit" [disabled]="submitting">
            @if (submitting) {
                <span class="file-modal__spinner" aria-hidden="true"></span>
            } @else {
                <span>{{ 'admin_action_save' | translate }}</span>
            }
        </button>
    </form>
</div>
